const floatRegex = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;

export { floatRegex };
